import styled from "styled-components";

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h1 {
    color: var(--f-7-c-13-a, #f7c13a);
    font-size: 26.09px;
    font-style: italic;
    font-weight: 400;
    line-height: 58.313px; /* 223.511% */
    margin-top: 0.5rem;
    opacity: 0.5;
  }

  p {
    color: #fff;
    text-align: center;
    font-size: 31.47px;
    font-style: italic;
    font-weight: 600;
    line-height: normal;
  }
`;
